import { Component, Input } from "@angular/core";
import { MetricMappingWeightingLevel } from "../driving-styles.enums";
import { IDrivingStyleMetricMapping } from "../driving-styles.interfaces";
import './driving-style-metric-weighting-label.component.scss';

@Component({
    selector: 'driving-style-metric-weighting-label',
    template: require('./driving-style-metric-weighting-label.component.html')
})
export class DrivingStyleMetricWeightingLabelComponent {

    @Input() metricMapping: IDrivingStyleMetricMapping;

    MetricMappingWeightingLevel = MetricMappingWeightingLevel;

    constructor() { }
}
